<template>
  <v-container class="pa-0" fluid>

    <v-row no-gutters v-show="hideOverlayRoute">
      <v-col v-if="showFilterPane" :cols="cols.filter" class="pane filterpane">
        <slot name="filter">
          filter
        </slot>
      </v-col>
      <v-col :cols="cols.list" class="pane">
        <slot name="list">
          list
        </slot>
      </v-col>
      <v-col v-if="showPreviewPane" :cols="cols.preview" class="pane previewpane inset">
        <slot name="preview">
          preview
        </slot>
      </v-col>
    </v-row>

    <!-- Used to render subroutes over this component without un -->
    <v-row no-gutters>
      <v-col cols="12" class="pane" v-if="!hideOverlayRoute" style="position: absolute; background-color: white;">
        <router-view @Added="e => $emit('Added', e)" @Changed="e => $emit('Changed', e)">
          Overlay Route Content
        </router-view>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "PreviewableListLayout",
  props: {
    hideFilter: {
      default: true,
      type: Boolean,
    },
    hidePreview: Boolean,
    hideOverlayRoute: {
      default: true,
      type: Boolean,
    },
  },
  components: {},

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {
    cols() {
      if (this.isPhoneBool) {
        return { filter: 12, list: 12, preview: 12 };
      }
      else if (this.isPadBool) {
        return { filter: 3, list: 0, preview: 5 };
      }
      else if (this.isUltrawideBool) {
        return { filter: 2, list: 0, preview: 3 };
      }
      else { // most laptop screens
        return {
          filter: (this.showPreviewPane ? 3 : 4),
          list: 0,
          preview: (this.showFilterPane ? 4 : 5)
        };
      }
    },

    showPreviewPane() {
      return !this.hidePreview;
    },
    showFilterPane() {
      return !this.hideFilter;
    },
  },

  watch: {},
};
</script>

<style lang="scss">
.pane {
  height: 100%;
  overflow-y: auto !important;
}

.filterpane {
  position: relative;
}

.filterpane:after {
  position: absolute;
  top: 48px;
  right: 0;
  height: calc(100% - 48px);
  border-right: solid 1px rgb(230, 230, 230);
  content: '';
}

@media only screen and (max-width: 600px) {
  .listpane {
    height: auto !important;
  }

  #ContentContainer .pane.previewpane {
    height: 0 !important;
  }
}
</style>